// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1ApMv","gfeWrapper":"CalendarEvent_gfeWrapper__3tPoL"};